import React from 'react';
import {
  Action,
  Actions,
  FileDownloadIcon,
  ActionBar,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { useScreenState, useScreenTitle } from '@gogame/screens';

import { useExportTable } from 'scenes/AuditLogs/data/mutations';

export default () => {
  const [screenTitle] = useScreenTitle();
  const screenState = useScreenState();
  const [exportTable] = useExportTable();

  const handleExport = () => {
    exportTable({
      filters: screenState.filters,
      settings: screenState.tableSettings,
    });
  };

  return (
    <>
      <ActionBar
        title={screenTitle}
        secondaryActions={
          <Actions>
            <Action
              icon={<FileDownloadIcon />}
              onClick={handleExport}
              label={'Export'}
            />
            <Action component={FullScreenToggler} />
          </Actions>
        }
      />
    </>
  );
};
